import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRedirect, DomainRoute } from '../utils/domain/routingComponents'
import { storeHoursBulkAccessControlView } from '../access-control/storeHoursBulkAccess.configuration'
import { useDomainScopedPathname } from '../utils/domain/routing'

const StoreHoursBulkListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "StoreHoursBulkListPage" */
      '../pages/list/StoreHoursBulkListPage'
    )
)
const StoreHoursBulkEditPage = lazy(
  () =>
    import(
      /* webpackChunkName: "StoreHoursBulkEditPage" */
      '../pages/edit/StoreHoursBulkEditPage'
    )
)
const StoreHoursBulkUpdateHistoryPage = lazy(
  () =>
    import(
      /* webpackChunkName: "StoreHoursBulkUpdateHistoryPage" */
      '../pages/update-history/StoreHoursBulkUpdateHistoryPage'
    )
)
const StoreHoursBulkHolidaysList = lazy(
  () =>
    import(
      /* webpackChunkName: "HolidayListPage" */
      '../pages/holidays-list/HolidaysListPage'
    )
)
const StoreHoursBulkHolidaysStoresConfirmedListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "StoreHoursBulkHolidaysStoresConfirmedListPage" */
      '../pages/holidays-stores-confirmed-list/StoreHoursBulkHolidaysStoresConfirmedListPage'
    )
)
// @hygen:inject page-import

export const storeHoursBulkRouter = (
  <DomainRoute route="store-hours-bulk" accessControl={storeHoursBulkAccessControlView}>
    <DashSwitch>
      <DomainRoute
        exact
        route="store-hours-bulk-list"
        tool="store-hours-dashboard-tool"
        component={StoreHoursBulkListPage}
        scopePicker={{
          titles: ['storeHoursBulkDomain.breadcrumbs.root'],
        }}
      />
      <DomainRoute
        exact
        route="store-hours-bulk-edit"
        tool="store-hours-dashboard-tool"
        component={StoreHoursBulkEditPage}
      />
      <DomainRoute
        exact
        route="store-hours-bulk-update-history"
        tool="store-hours-dashboard-tool"
        component={StoreHoursBulkUpdateHistoryPage}
      />
      <DomainRoute
        exact
        route="holiday-list"
        tool="holiday-hours-dashboard-tool"
        component={StoreHoursBulkHolidaysList}
        scopePicker={{
          titles: [
            'storeHoursBulkDomain.breadcrumbs.root',
            'storeHoursBulkDomain.breadcrumbs.holidayHours',
          ],
        }}
      />
      <DomainRoute
        exact
        route="store-hours-bulk-holidays-stores-confirmed-list"
        tool="holiday-hours-dashboard-tool"
        component={StoreHoursBulkHolidaysStoresConfirmedListPage}
        routeRequirements={{
          partnerIdRequired: true,
          retailerIdRequired: true,
          redirectRouteIfRequirementsNotMet: {
            useScopedPathname: (params: Record<string, string>) =>
              useDomainScopedPathname('holiday-list', params),
          },
        }}
      />
      {/* @hygen:inject router-route 
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
